// Packages and components
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Box } from 'grommet';

// Helpers and utilities
import { getComponentClassName } from '@theme/utils/data';
import { ResponsiveContext } from 'grommet';

// Types
import type { SHDModalContainerProps } from './SHDModalContainer.d';
import type { PadType } from 'grommet/utils';

// TODO Change this to the class-based system.
// TODO Change the name here and in other instances.
// TODO Add utility classes for is-first and is-last.

const SHDModalContainer: React.FC<SHDModalContainerProps> = ({
  className,
  children,
  horizontal = true,
  isFirst = false,
  isLast = false,
  vertical = true,
  gap = 'none',
  ...props
}) => {
  const componentClassName = 'padding-container';

  // States
  const [utilityClassNames, setUtilityClassNames] = useState<string[]>();

  // Hooks and contexts
  const viewportSize = useContext(ResponsiveContext);

  // Handlers
  const handlePadding = useCallback(() => {
    const padding: PadType = {
      top: 'large',
      bottom: 'large',
      left: 'large',
      right: 'large',
    };

    if (!horizontal) {
      padding.left = 'none';
      padding.right = 'none';
    }

    if (!vertical) {
      padding.top = 'none';
      padding.bottom = 'none';
    }

    if (isFirst) {
      padding.top = 'none';
    }

    if (isLast) {
      padding.bottom = 'none';
    }

    return padding;
  }, [horizontal, vertical, isFirst, isLast]);

  const handleUtilityClassNameUpdates = useCallback(() => {
    const utilityClassArr: string[] = [];
    if (className) {
      className.split(' ').forEach((name) => {
        utilityClassArr.push(name);
      });
    }
    // Viewport size
    utilityClassArr.push(`is-${viewportSize}`);
    setUtilityClassNames(utilityClassArr);
  }, [className, viewportSize]);

  // Effects
  useEffect(() => {
    handleUtilityClassNameUpdates();
  }, [handleUtilityClassNameUpdates]);

  return (
    <Box
      {...props}
      className={getComponentClassName(componentClassName, utilityClassNames)}
      pad={handlePadding()}
      gap={gap}
    >
      {children}
    </Box>
  );
};

export default SHDModalContainer;
